import { gql } from 'apollo-boost'

const SCRAPING_RESPONSE_REPORT_URL = gql`
  query scrapingResponseReportUrl($scrapingResponseId: ID!) {
    scrapingResponseReportUrl(scrapingResponseId: $scrapingResponseId)
  }
`

export default SCRAPING_RESPONSE_REPORT_URL
